export default {
  colors: {
    'chakra-border-color': { _light: 'gray.200', _dark: 'whiteAlpha.200' },
    muted: {
      default: 'gray.500',
      _dark: 'gray.400',
    },
    neutral: {
      default: 'black',
      _dark: 'white',
    },
    'neutral-fg': {
      default: 'white',
      _dark: 'black',
    },
  },
}
